module.exports = __webpack_public_path__ + "static/img/19.4fd2fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/19.jpg
// module id = ZaYT
// module chunks = 1